<template>
  <div class="file-container">
    <!-- <input type="file" name @change="fileUpload($event)"> -->
    <img
      class="close remove"
      src="../../assets/images/jidayi-hospital/icon-img-close.png"
      alt
      @click="clear"
      v-if="val"
    />
    <!-- <mt-spinner
      v-if="uploadStatus"
      class="upload-icon"
      type="snake"
      color="#ffffff">
    </mt-spinner> -->
    <div class="porgress" :style="{'opacity':uploadStatus && !isUrl(val)?'1':'0'}">
      <div class="text">{{(progress*100).toFixed(2)+'%'}}</div>
      <div class="pie"><i :style="{'width':(progress*100)+'%'}"></i></div>
    </div>
    <img class="file-image" :src="val" alt v-if="val" @click="showFullImg(val)"/>
    <div class="file-empty" v-else>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageCard',
  props: {
    file: {
      required: false,
      default: null
    },
    isUpload: {
      type: Boolean,
      required: false,
      default: false
    },
    progress: {
      default: 0
    },
    timestamp: {
      default: 0
    }
  },
  components: {
  },
  data () {
    return {
      val: ''
    }
  },
  computed: {
    uploadStatus () {
      return this.isUpload
    },
    degVal () {
      console.log(this.progress)
      return `rotate(${this.progress * 180}deg)`
    }
  },
  created () {
    this.init()
  },
  methods: {
    /*
     * 验证输入是否是合法url地址
     * @val:字符串
     */
    isUrl: function (val) {
      var p = /^(?:http(?:s)?:\/\/)?([\w-]+\.)+[\w-]+(?:\/[\w- .\/\?%&=]*)?$/

      if (p.test(val)) {
        return true
      } else {
        return false
      }
    },
    init () {
      if (typeof this.file === 'object') {
        this.handleFile()
      } else {
        this.val = this.file
      }
    },
    clear () {
      this.$emit('remove', '')
    },
    handleFile () {
      let reader = new FileReader()
      reader.readAsDataURL(this.file)
      reader.onload = e => {
        this.val = e.target.result
      }
    },
    showFullImg (src) {
      this.$store.dispatch('showFullscreenImg', {
        src
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/ImageCard.vue